import {createContext,useContext} from 'react'
import { makeAutoObservable, runInAction } from "mobx";
import {getMethodData,putMethod, patchMethodData, postFormData} from "../../ApiMethods/api"
import { toast } from "react-toastify";

export class BadWordStore {
    Token = null;
    indexPage=1;
    activePage=1;
    checkbox = 0;
    Count=1;
    perPage="";
    filterVisibility=true;
    ctas = [];
    loadCta = false;
    errloadCta = "";
    nolist = false;
    filtertrue=false;
    singleCta;
    nofilterwithpagination= false;
    addloadcta= false;
    addedloadcta= false;
    erraddcta="";
    name= "";
    keywords="";
    status="";
    image="";
    imageurl="";
    Screen="";
    price= "";
    ctaid= "";
    link="";
    saved = false;
    content="";

    loadProducttype=false;
    errProducttypelist = "";
    noProducttypelist=true;
    Producttypelist=[]
    previousValues = {
      name: "",
      status:"",
      type_id:""
    };

    constructor(isloading = false) {
        makeAutoObservable(this);
       
        this.Token = localStorage.getItem("Admintoken");
        if(isloading.isloadingtype){

        }
        if(isloading.isloading){
            this.getBadWords(isloading.pagginationcount);
            return
        }
        if(isloading.editloading){
            this.getBadWordOne(isloading.id);

            return
        }
    }

    setname = (text) =>  {
        this.name = text;
    }
    setToken = (text) =>  {
      this.Token = text;
    }
    setScreen = (text) =>  {
      this.Screen = text;
  }
    setkeywords = (text) =>  {
        this.keywords = text;
    }
    setstatus = (text) =>  {
        this.status = text;
    }
    setimage = (text) =>  {
      if(text){
        this.image = text;
        this.imageurl = URL.createObjectURL(text);
      }else{
        this.image = "";
        this.imageurl ="";
      }
    }

    setlink = (text) =>  {
      this.link = text;
  }

    getstatusid = (text) => {
        this.ctaid = text;
    }
    setActivePage = (text) =>{
      this.activePage = text;
    }
    setIndexPage=(e)=>{
      this.indexPage=e;
    }
    setCount=(e)=>{
      this.Count=e;
    }
    setPerPage=(e)=>{
      this.perPage=e;
    }
    setFilterVisibility=(e)=>{
      this.filterVisibility=e;
    }
    setcheckbox=(text)=>{
      this.checkbox =text
  
    }
    NofilterwithPagination = (e) => {
      runInAction(() => {
          this.nofilterwithpagination = e
      })
    }
    setcontent=(e)=>{
      this.content=e;
    }

           // get product type list
           getProducttypeList = (Token) => {
            runInAction(() => {
              this.loadProducttype = true;
              this.errProducttypelist = "";
            });
            getMethodData(`/admin/product-types`, this.Token||Token)
              .then((resp) => {
                if (resp?.data?.status === false) {
                  runInAction(() => {
                    this.loadProducttype = false;
                    this.errProducttypelist = "";
                  });
                  return;
                }
                if (resp?.data?.status === true) {
                  runInAction(() => {
                    this.loadProducttype = false;
                    this.errProducttypelist = resp?.data?.message;
                    if (resp?.data?.data?.length === 0) {
                      this.noProducttypelist = true;
                    } else {
                      this.noProducttypelist = false;
                    }
                    this.Producttypelist = resp?.data?.data;
                  });
                  return;
                }
                runInAction(() => {
                  this.loadProducttype = false;
                  this.errProducttypelist = resp?.data?.message;
                });
              })
              .catch((error) => {
                runInAction(() => {
                  this.loadProducttype = false;
                  if (!error.response) {
                    toast.error(error?.message);
                  }
                  toast.error(error?.response?.data?.message);
                });
                return;
              });
          };

        // get cta List
        getBadWords = (pageNumber,Token) => {
            runInAction(() => {
                this.loadCta = true;
                this.errloadCta = "";
                this.saved = false;
                this.ctas=[];
                this.indexPage = pageNumber;
                });
            // getMethodData("/admin/ctas",this.Token)
            getMethodData(`/admin/bed-words?page=${pageNumber}`,this.Token||Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message;
                    // console.log(resp?.data?.data.length);
                    if(resp?.data?.data?.data?.length === 0) {
                        this.nolist = true;
                    }else{
                        this.nolist = false;
                    }
                    // console.log(resp?.data?.data?.data)
                    this.ctas = resp?.data?.data?.data;
                    this.Count = resp?.data?.data?.total;
                    this.perPage = resp?.data?.data?.per_page;
                    this.activePage = resp?.data?.data?.current_page;
                    this.saved = false;
                    this.filterVisibility = true;
                    // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message;
                });
                })
                .catch((error) => {
                runInAction(() => {
                    this.loadCta = false;
                    if(!error.response){
                        this.errloadCta = error?.message;
                        toast.error(error?.message);
                    }
                    this.errloadCta = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
        };
        loadTableData = async (pageNumber) => {
          runInAction(() => {
            this.loadCta = true;
            this.errloadCta = "";
            this.saved = false;
            this.setIndexPage(1);
            });
          try {
            const response = await getMethodData(`/admin/bed-words?page=${pageNumber === 1 ? 1 : pageNumber}`,this.Token)
            if (response?.data?.status === false) {
              runInAction(() => {
              this.loadCta = false;
              this.errloadCta = response?.data?.message
              });
              return;
          }
          if (response?.data?.status === true) {
            runInAction(() => {
              this.loadCta = false;
              this.errloadCta = response?.data?.message;
              // console.log(resp?.data?.data.length);
              if(response?.data?.data?.data?.length === 0) {
                  this.nolist = true;
              }else{
                  this.nolist = false;
              }
                this.setCount(response.data.data.total);
                this.setPerPage(response.data.data.per_page);
                this.setActivePage(response.data.data.current_page)
                this.ctas = response?.data?.data?.data;
                this.filterVisibility = true;
    });
          }
    
        
      
          } catch (error) {
            runInAction(() => {
              this.loadCta = false;
              console.error("Error loading table data:", error);
          });
          }
        };
            //get cta edit data (show)

    getBadWordOne =(id) => {
        getMethodData( `/admin/bed-words/edit/${id}`, this.Token)
        .then((resp) => {
            runInAction(() => {
                this.loadCta = true;
                this.errloadCta = "";
              });
          if (resp?.data?.status === false) {
            runInAction(() => {
              this.loadCta = false;
              this.errloadCta = resp.data.message;
              // toast.error(resp.data.message);
            });
            return;
          }
          if (resp?.data?.status === true) {
            runInAction(() => {
                this.loadCta = false;
                this.name = resp?.data?.data?.word
            })
            return;
          }
          runInAction(() => {
            this.loadCta = false;
            this.errloadCta = resp.data.message;
            toast.error(resp.data.message);
          });
        })
        .catch((error) => {
          runInAction(() => {
              if(!error.response){
                this.loadCta = false;
                this.errloadCta = error?.message;
                toast.error(error?.message);
              }
                toast.error(error?.response?.data?.message);
                this.loadCta = false;
                this.errloadCta = error?.response?.data?.message;
          })
          return;
      })
    }


         // cta add

 addBadWord = () => {
    runInAction(() => {
      this.addedloadcta = true;
      this.erraddcta = "";
    });
    const formData = new FormData();
    formData.append("word", this.name);
    postFormData(`/admin/bed-words/store`,formData,this.Token)
      .then((resp) => {
        if (resp?.data?.status === false) {
          runInAction(() => {
            this.addedloadcta = false;
            this.erraddcta = resp?.data?.message;
            toast.error(resp.data?.data?.errors?.word[0]);
          });
          return;
        }
        if (resp?.data?.status === true) {
          runInAction(() => {
              this.addedloadcta = false;
              this.erraddcta = resp?.data?.message;
              toast.success(resp.data.message);
              //  this.getBadWords();
              this.saved = true;
            })
            return
        }
        runInAction(() => {
          this.addedloadcta = false;
          this.erraddcta = resp?.data?.message;
          toast.error(resp.data.message);
        });
      })
      .catch((error) => {
        
        runInAction(() => {
            if(!error.response){
                
              this.addedloadcta = false;
              this.erraddcta = error?.message;
              toast.error(error?.message);
            }
                
              toast.error(error?.response?.data?.message);
              this.addedloadcta = false;
              this.erraddcta = error?.response?.data?.message;
        })
        return;
    })
  };

  editBadWord = (id) => {
    runInAction(() => {
      this.addloadcta = true;
      this.erraddcta = "";
    });
    
    const formData = new FormData();
    formData.append("word", this.name);

    postFormData(`/admin/bed-words/update/${id}`, formData, this.Token)
      .then((resp) => {
        if (resp?.data?.status === false) {
          runInAction(() => {
            this.addloadcta = false;
            this.erraddcta = resp?.data?.message;
            toast.error(resp.data?.data?.errors?.word[0]);
          });
          return;
        }
        if (resp?.data?.status === true) {
          runInAction(() => {
              this.addloadcta = false;
              this.erraddcta = resp?.data?.message;
              toast.success(resp.data.message);
              //  this.getBadWords();
              this.saved = true;
            });
            return;
        }
        runInAction(() => {
          this.addloadcta = false;
          this.erraddcta = resp?.data?.message;
          toast.error(resp.data.message);
        });
      })
      .catch((error) => {
        runInAction(() => {
            if (!error.response) {
              this.addloadcta = false;
              this.erraddcta = error?.message;
              toast.error(error?.message);
            } else {
              toast.error(error?.response?.data?.message);
              this.addloadcta = false;
              this.erraddcta = error?.response?.data?.message;
            }
        });
        return;
    });
};


    //Active and inactive
statusChange = (currentPage) => {
    runInAction(() => {
      this.loadCta = true;
      this.errloadCta = "";
    });
    getMethodData(`/admin/bed-words/change-status/${this.ctaid}`,this.Token)
      .then((resp) => {
        if (resp?.data?.status === false) {
          runInAction(() => {
            this.loadCta = false;
            this.errloadCta = resp?.data?.message;
            // toast.error(resp?.data?.message);
          });
          return;
        }
        if (resp?.data?.status === true) {
          runInAction(() => {
            this.loadCta = false;
            this.errloadCta = resp?.data?.message;
            this.getBadWords(currentPage ?? 1);
            toast.success(resp?.data?.message);
          })
          this.setIndexPage(currentPage);
          return;
        }
        runInAction(() => {
          this.loadCta = false;
          this.errloadCta = resp?.data?.message;
        })
      })
      .catch((error) => {
        runInAction(() => {
            if(!error.response){
              this.loadCta = false;
              this.errloadCta = error?.message;
              toast.error(error?.message);
            }
              toast.error(error?.response?.data?.message);
              this.loadCta = false;
              this.errloadCta = error?.response?.data?.message;
        })
        return;
    })
  };
setfiltertrue=(e)=>{
  this.filtertrue = e;
}

     //filter user api 

     getFilterBadWord = (page,Token) => {
        runInAction(() => {
            this.activePage = page;
            this.loadCta = true;
            this.indexPage = page;
            this.errloadCta = "";
            this.saved = false;
            this.ctas=[];
            if(!this.nofilterwithpagination){
              this.previousValues = {
                name: this.name,
              };
            }
          });
      
          if(this.nofilterwithpagination){
            getMethodData(`/admin/bed-words?page=${page}&word=${ this.previousValues?.name}`,this.Token||Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                  runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message
                  });
                  return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.loadCta = false;
                        this.filtertrue = true;
                        this.errloadCta = resp?.data?.message;
                        // console.log(resp?.data?.data.length);
                        if(resp?.data?.data?.data?.length === 0) {
                            this.nolist = true;
                        }else{
                            this.nolist = false;
                        }
                        // console.log(resp?.data?.data?.data)
                        this.ctas = resp?.data?.data?.data;
                        this.Count = resp.data.data.total;
                        this.perPage = resp.data.data.per_page;
                        this.activePage = resp?.data?.data?.current_page;
                        this.saved = false;
                        this.filterVisibility = true;
                        // this.status = true;
                        });
                  return;
                }
                runInAction(() => {
                  this.loadCta = false;
                  this.errloadCta = resp?.data?.message;
                });
              })
              return;
            
          }
        getMethodData(`/admin/bed-words?page=${page}&word=${this.name}`,this.Token||Token)
        .then((resp) => {
            if (resp?.data?.status === false) {
              runInAction(() => {
                this.loadCta = false;
                this.errloadCta = resp?.data?.message
              });
              return;
            }
            if (resp?.data?.status === true) {
                runInAction(() => {
                    this.loadCta = false;
                    this.filtertrue = true;
                    this.errloadCta = resp?.data?.message;
                    // console.log(resp?.data?.data.length);
                    if(resp?.data?.data?.data?.length === 0) {
                        this.nolist = true;
                    }else{
                        this.nolist = false;
                    }
                    // console.log(resp?.data?.data?.data)
                    this.ctas = resp?.data?.data?.data;
                    this.Count = resp.data.data.total;
                    this.perPage = resp.data.data.per_page;
                    this.activePage = resp?.data?.data?.current_page;
                    this.saved = false;
                    this.filterVisibility = true;
                    // this.status = true;
                    });
              return;
            }
            runInAction(() => {
              this.loadCta = false;
              this.errloadCta = resp?.data?.message;
            });
          })
          .catch((error) => {
            runInAction(() => {
                this.loadCta = false;
                if(!error.response){
                    this.errloadCta = error?.message;
                    toast.error(error?.message);
                }
                this.errloadCta = error?.response?.data?.message;
                toast.error(error?.response?.data?.message);
            })
            return;
        });
    };


};


export const BadWordStoreContext = createContext(new BadWordStore());
export const useBadWordStore = () => useContext(BadWordStoreContext);